import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import cn from "classnames";
import { validateEmail } from "../../../../utils/checkEmail";
import stylesCommon from "../../common.module.scss"
import styles from "../../RegistrationPageNew/page.module.scss";
import CustomInput from "../../../custom/custom-input/CustomInput";
import CustomButton from "../../../custom/custom-button/CustomButton";
import CustomSwitch from "../../../custom/custom-switch/CustomSwitch";
import CloseIcon from "../../../shared/icons/CloseIcon";
import { User } from "../../../../services";
import { toast } from "react-toastify";
import { requestErrorDisplay } from "../../../../utils";
import { useTranslation } from 'react-i18next'; // Import useTranslation

// const validatePassword = (password) => {
//   if (password.length < 6) {
//     return "Длина пароля должна быть не менее 6 символов";
//   }
//   if (!/[A-Z]/.test(password)) {
//     return "Пароль должен содержать заглавную букву";
//   }
//   if (!/[a-z]/.test(password)) {
//     return "Пароль должен содержать строчную букву";
//   }
//   if (!/\d/.test(password)) {
//     return "Пароль должен содержать минимум одну цифру";
//   }
//   return false;
// };

const validatePhoneNumber = (phoneNumber) => {
  // Keep original validation logic
  const combinedPattern = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$|^7\d{10}$/;
  return combinedPattern.test(phoneNumber);
};

// Pass t function for translations
const validateUserName = (userName, t) => {
  if (!userName || userName.trim() === "") {
    return { isValid: false, errorMessage: t('registrationForm.validation.enterFullName') };
  }

  const nameParts = userName.trim().split(/\s+/);

  if (nameParts.length < 2) {
    return { isValid: false, errorMessage: t('registrationForm.validation.enterFullNameRequired') };
  }

  const namePattern = /^[A-Za-zА-Яа-я]+(-[A-Za-zА-Яа-я]+)*$/;

  for (const part of nameParts) {
    if (!namePattern.test(part)) {
      return {
        isValid: false,
        errorMessage: t('registrationForm.validation.fullNameInvalidChars')
      };
    }
  }

  return { isValid: true, errorMessage: null };
};

const FormRegistration = ({ data, updateStep, setData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [userName, setUserName] = useState(`${data.surname || ''} ${data.name || ''} ${data.patronymic || ''}`.trim());
  const [phoneNumber, setPhoneNumber] = useState(data?.phoneNumber || '');
  const [email, setEmail] = useState(data?.email || '');
  const [password, setPassword] = useState(data?.password || '');
  const [isChecked, setIsChecked] = useState(data?.isChecked || false);
  const [isCheckedEmail, setIsCheckedEmail] = useState(true);
  const [isCheckedPhone, setIsCheckedPhone] = useState(true);

  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [patronymic, setPatronymic] = useState('');

  const [errorTitleName, setErrorTitleName] = useState();
  const [errorTitlePhone, setErrorTitlePhone] = useState();
  const [errorTitleEmail, setErrorTitleEmail] = useState();
  const [errorTitlePassword, setErrorTitlePassword] = useState();
  const [errorIsChecked, setErrorIsChecked] = useState();

  useEffect(() => {
    if (data.phoneNumber) setPhoneNumber(data.phoneNumber);
    if (data.email) setEmail(data.email);
    if (data.surname || data.name || data.patronymic) {
      const fullName = `${data.surname || ''} ${data.name || ''} ${data.patronymic || ''}`.trim();
      setUserName(fullName);
    }
  }, [data]);

  useEffect(() => {
    console.log('[data]', data);
  }, [data]);

  useEffect(() => {
    if (!userName) return;
    const names = userName.trim().split(/\s+/);
  
    if (names.length === 1) {
      setSurname('');
      setName(names[0]);
      setPatronymic('');
    } else {
      setSurname(names[0] || '');
      setName(names[1] || '');
      setPatronymic(names.length > 2 ? names[2] : '');
    }
    setErrorTitleName(null);
  }, [userName]);
  

  const validateData = async () => {
    setErrorTitleName(null);
    setErrorTitleEmail(null);
    setErrorTitlePhone(null);
    setErrorTitlePassword(null);
    setErrorIsChecked(null);

    if (!userName) {
      setErrorTitleName(t('registrationForm.validation.enterFullName'));
      return;
    }

    // const nameValidation = validateUserName(userName, t);
    // if (!userName) {
    //   setErrorTitleName(nameValidation.errorMessage);
    //   return;
    // }

    if (!phoneNumber) {
      setErrorTitlePhone(t('registrationForm.validation.invalidPhoneFormat'));
      return;
    }
    if (phoneNumber.length < 8) {
      setErrorTitlePhone(t('registrationForm.validation.invalidPhoneFormat'));
      return;
    }
    if (!validateEmail(email)) {
      setErrorTitleEmail(t('registrationForm.validation.invalidEmailFormat'));
      return;
    }
    if (!password) {
      setErrorTitlePassword(t('registrationForm.validation.passwordEmpty'));
      return;
    }
    if (password.length < 1) {
      setErrorTitlePassword(t('registrationForm.validation.passwordInsecure'));
      return;
    }
    // if (!isChecked) {
    //   toast.error(t('registrationForm.validation.confirmTerms'));
    //   setErrorIsChecked(t('registrationForm.validation.confirmTermsCheckbox'));
    //   return;
    // }

    // let formattedPhoneNumber = phoneNumber.replace(/\D/g, '');
    // const isPhoneValid = await checkPhone(phoneNumber);
    // if (!isPhoneValid) return;

    const isEmailValid = await checkEmail(email);
    if (!isEmailValid) return;

      setData({
        ...data,
        name: name,
        surname: surname,
        patronymic: patronymic,
        phoneNumber: phoneNumber,
        email: email,
        password: password,
        isChecked: isChecked,
      });
      setIsOpenModal(true);
  };

  const checkEmail = async (emailToCheck) => {
    try {
      const response = await User.checkEmail(emailToCheck);
      if (response.status === 200 && response.data.isExists) {
        toast.error(t('registrationForm.validation.emailExists'));
        setErrorTitleEmail(t('registrationForm.validation.emailExists'));
        setIsCheckedEmail(false);
        return false;
      }
      setIsCheckedEmail(true);
      return true;
    } catch (error) {
      requestErrorDisplay(error, t, 'registrationForm.error.generic');
      return false;
    }
  };

  const checkPhone = async (phoneToCheck) => {
    try {
      const response = await User.checkPhone(phoneToCheck);
      if (response.status === 200 && response.data.isExists) {
        toast.error(t('registrationForm.validation.phoneExists'));
        setErrorTitlePhone(t('registrationForm.validation.phoneExists'));
        setIsCheckedPhone(false);
        return false;
      }
      setIsCheckedPhone(true);
      return true;
    } catch (error) {
      requestErrorDisplay(error, t, 'registrationForm.error.generic');
      return false;
    }
  };

  const handleToggle = (newState) => {
    setIsChecked(newState);
  };

  const nextStep = () => {
    if (!isCheckedEmail || !isCheckedPhone) {
      setIsOpenModal(false);
      return;
    } else updateStep(2);
  }

  const handleClose = () => {
    setIsOpenModal(false);
  }

  return (
    <>
      <form className={styles.card_form}>
        <CustomInput
          placeholder={t('registrationForm.placeholder.enterFullName')}
          labelText={t('registrationForm.label.fullName')}
          inputType="text"
          onChangeValue={setUserName}
          value={userName}
          errorText={errorTitleName}
        />
        <CustomInput
          placeholder={t('registrationForm.validation.enterPhone')}
          labelText={t('registrationForm.label.phone')}
          inputType="text"
          onChangeValue={setPhoneNumber}
          value={phoneNumber}
          // isPhone={true}
          errorText={errorTitlePhone}
          isPhoneCn
        />
        <CustomInput
          placeholder={t('login.emailPlaceholder')} // Reuse login placeholder
          labelText={t('login.emailLabel')} // Reuse login label
          inputType="text"
          onChangeValue={setEmail}
          value={email}
          errorText={errorTitleEmail} />
        <CustomInput
          placeholder={t('registrationForm.placeholder.createPassword')}
          labelText={t('registrationForm.label.password')}
          inputType="text"
          isPasswordEye={true}
          onChangeValue={setPassword}
          value={password}
          errorText={errorTitlePassword}
        />

        {/* <div className={styles.card_offer}>
          <div className={styles.card_text}>
            <span>
              {t('login.termsAgreement')} <a href="https://app.biny.co/privacy-policy.pdf" target="_blank" rel="noopener noreferrer">{t('login.termsLink')}</a>{t('login.service')}
            </span>
            <CustomSwitch onToggle={handleToggle} defaultValue={isChecked} />
          </div>
          { errorIsChecked && <div className={styles.errorText}>{errorIsChecked}</div> }
        </div> */}
      </form>

      <div className={styles.btns}>
        <CustomButton isFall text={t('registrationForm.button.continue')} onClick={validateData} isLoading={isLoading} />
        {/* <div className={styles.btns_text}>
          <div className={styles.btns_before}></div>
          <div className={styles.btns_textDashes}>{t('login.registrationPrompt')}</div>
          <div className={styles.btns_before}></div>
        </div>
        <CustomButton isFall text={t('login.loginButton')} isWhite={true} onClick={() => navigate('/login')} /> */}
      </div>

      {isOpenModal &&
        <div className={cn("modal-overlay", stylesCommon.modal)}>
          <div className={cn(stylesCommon.modal_content)}>
            <div className={stylesCommon.modal_text}>
              <div className={stylesCommon.modal_title}>{t('registrationForm.modal.confirmEmailTitle')} <CloseIcon fill={'#6D7885'} onClick={handleClose} /> </div>
              <div className={stylesCommon.modal_description}>{t('registrationForm.modal.confirmEmailText', { email: email })}</div>
            </div>
            <CustomInput
              placeholder={t('login.emailPlaceholder')} // Reuse login placeholder
              labelText={t('login.emailLabel')} // Reuse login label
              inputType="text"
              onChangeValue={setEmail}
              value={email}
              errorText={errorTitleEmail}
              isDisabled />
            <div className={stylesCommon.modal_btns}>
              <CustomButton isFall text={t('registrationForm.modal.confirmButton')} onClick={nextStep} />
              <CustomButton isFall text={t('registrationForm.modal.changeEmailButton')} isUnderline onClick={handleClose} />
            </div>
          </div>
        </div>
      }
    </>

  );
};

export default FormRegistration;
